module.exports = __webpack_public_path__ + "static/media/bot-popup-rules.e61253a5.png";